import React from "react"
import styled from "styled-components"

import { DrupalLink } from "../../utils/drupal"
import { ArrowRight } from "react-feather"

export default ({ title, links }) => (
  <Style>
    {title ? <h3>{title}</h3> : null}
    <ul>
      {links.map((link, i) => (
        <li key={i}>
          <DrupalLink to={link.uri}>
            <ArrowRight /> {link.title}
          </DrupalLink>
        </li>
      ))}
    </ul>
  </Style>
)

const Style = styled.div.attrs((props) => ({
  className: "promotion promotion--link-group prose",
}))`
  > h3 {
    font-weight: 600;
  }

  > ul {
    list-style: none;
    padding: 0;
    margin: 0;

    > li {
      margin-bottom: 0;
      margin-top: 1.5em;
    }
  }

  a {
    color: var(--textColor);
    display: inline-flex;
    align-items: baseline;

    svg {
      max-width: 0.75em;
      margin-right: 0.5em;
      height: 1em;
      transform: translateY(0.15em);
    }

    &:hover,
    &:focus {
      color: ${(props) => props.theme.colors.primary};
    }
  }
`
